<template>
  <div class="content">
    <div class="title">
      <div class="left-success">
        <div><i class="el-icon-success"></i></div>
        <div class="introduce">
          <div>匹配完成，符合该政策的企业共 {{ entList.totalRecord }} 家</div>
          <div>根据企业实际情况进行政策匹配，时间可能较慢，请耐心等待</div>
        </div>
      </div>
      <rotate-icon></rotate-icon>
    </div>
    <div class="table-list">
      <div class="table-top">
        <div class="table-title">企业列表</div>
        <div>
          <el-button type="primary" @click="submit()" :loading="loading"
            >一键推送</el-button
          >
          <el-button @click="downLoad()">下载企业名单</el-button>
        </div>
      </div>
      <el-table
        :data="listData"
        style="width: 100%"
        :header-cell-style="{ background: '#fafafa' }"
        height="500px"
      >
        <el-table-column
          prop="entName"
          label="企业名称"
          width="250"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column prop="county" label="所属区域"></el-table-column>
        <el-table-column prop="frName" label="法人"></el-table-column>
        <el-table-column
          prop="industryName"
          label="行业门类名称"
        ></el-table-column>
      </el-table>
      <div class="table-page">
        <el-pagination
          background
          layout="total,prev, pager, next, sizes, jumper"
          :current-page.sync="entList.pageNum"
          @size-change="handleEntListSizeChange"
          @current-change="handleEntListCurrentChange"
          :page-size="entList.pageSize"
          :total="entList.totalRecord"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getEntDataPage,
  exportDataPage,
  updatePolicyData,
  addEntDatas,
  getMapProcess,
  updatePolicyDataById
} from '@api/yardPolicy/policyManagement/index'
import rotateIcon from './rotateIcon'
export default {
  name: 'MatchSetting',
  data() {
    return {
      listData: [],
      entNum: 0,
      entList: {
        pageNum: 1,
        pageSize: 10,
        totalRecord: 0
      },
      loading: false,
      timer: null
    }
  },
  components: { rotateIcon },
  props: {
    areaSelect: {
      type: String,
      default: ''
    },
    id: {
      type: Number,
      default: null
    },
    policyName: {
      type: String,
      default: ''
    },
    labelSelect: {
      type: String,
      default: ''
    }
  },
  watch: {
    areaSelect() {
      this.getEntDataPage()
    },
    labelSelect() {
      this.getEntDataPage()
    }
  },
  mounted() {
    this.getEntDataPage()
  },
  methods: {
    // 跳转政策消息推送
    async submit() {
      await this.saveLabelSetting()
      this.addEntDatas()
    },
    saveLabelSetting() {
      const params = {
        id: this.id,
        areaNameStr: this.areaSelect,
        lableNameStr: this.labelSelect
      }
      return new Promise((resolve, reject) => {
        updatePolicyDataById(params).then((res) => {
          if (res.data.code == '0000') {
            resolve()
          }
        })
      })
    },
    addEntDatas() {
      const params = {
        id: this.id,
        countyList: this.areaSelect ? this.areaSelect.split(',') : [],
        labelCodeList: this.labelSelect ? this.labelSelect.split(',') : []
      }
      addEntDatas(params).then((res) => {
        if (res.data.code == '0000') {
          setTimeout(() => {
            this.loading = true
            this.getMapProcess(res.data.data)
            this.timer = setInterval(this.getMapProcess, 3000, res.data.data)
          })
        }
      })
    },
    getMapProcess(key) {
      const params = {
        key: key
      }
      getMapProcess(params).then((res) => {
        const { data, code, msg } = res.data
        const process = Number(data.process)
        if (process == 1) {
          clearInterval(this.timer)
          this.loading = false
          this.$router.push({
            name: 'policyMessagePush',
            query: {
              id: this.id,
              policyName: this.policyName
            }
          })
        }
      })
    },
    // 根据筛选的区域和标签匹配查询企业
    getEntDataPage() {
      const params = {
        pageNum: this.entList.pageNum,
        pageSize: this.entList.pageSize,
        areaNames: this.areaSelect,
        lableNames: this.labelSelect
      }
      getEntDataPage(params).then((res) => {
        const { code, data, msg } = res.data
        if (code == '0000') {
          this.listData = data.results
          this.entList.totalRecord = data.totalRecord
          this.successDrawerVisible = true
        }
      })
    },
    // 匹配切换分页
    handleEntListCurrentChange(val) {
      this.entList.pageNum = val
      this.getEntDataPage()
    },
    // 匹配切换size
    handleEntListSizeChange(val) {
      this.entList.pageSize = val
      this.getEntDataPage()
    },
    downLoad() {
      const params = {
        areaNameStr: this.areaSelect,
        lableNameStr: this.labelSelect
      }
      exportDataPage(params)
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  height: calc(100% - 80px);
  .title {
    padding: 20px 16px 10px;
    border-radius: 5px;
    background: linear-gradient(90deg, #d6e5ff, #eaf1ff);
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
    .left-success {
      display: flex;
      align-items: center;
      i {
        font-size: 38px;
        color: rgba(0, 119, 255, 100);
        margin-right: 12px;
      }
      .introduce {
        display: flex;
        flex-direction: column;
        height: 100%;
        font-weight: 700;
        div:first-child {
          color: rgba(0, 119, 255, 100);
          font-size: 18px;
          margin-bottom: 10px;
        }
        div:nth-child(2) {
          font-size: 12px;
        }
      }
    }
  }
  .table-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
    .table-title {
      color: rgba(0, 0, 0, 0.85);
      font-size: 16px;
    }
  }
  .table-page {
    margin: 20px 0;
  }
}
</style>
